import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.socialMarketPair,
    (state) => state
)

export const selectPair = createSelector(
    baseSelector,
    (state) => state.pair
)

export const selectChart = createSelector(
    baseSelector,
    (state) => state.chart
)

export const selectChartLoading = createSelector(
    baseSelector,
    (state) => state.isChartLoading
)

export const selectPairGlass = createSelector(
    baseSelector,
    (state) => state.glass
)

export const selectPairGlassLoading = createSelector(
    baseSelector,
    (state) => state.isGlassLoading
)

export const selectChartInterval = createSelector(
    baseSelector,
    (state) => state.chartInterval
)

export const selectChartCount = createSelector(
    baseSelector,
    (state) => state.chartCount
)